import { FaLinkedinIn, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAllServices } from "../../Api";

const Footer = ({ language = "EN" }) => {

  const [services, setServices] = useState([]);

  const langKey = language === "CN" ? "zh" : "en";
  const lang = language === "CN" ? "zh" : "en";


  const text = {

    en: {
      journey: "Journeying Together",
      desc: "Financial advisory solutions for individuals and businesses in Singapore.",

      contact: "Contact Us",
      quick: "Quick Links",
      services: "Services",

      about: "About Us",
      meet: "Meet Our Team",
      stay: "Stay Connected",
      careers: "Careers",
      contactus: "Contact Us",

      privacy: "Privacy Policy",
      terms: "Terms & Conditions",

      hours: "Mon – Fri: 9:00 AM – 6:00 PM",

      address1: "371 Alexandra Road, #05-11",
      address2: "Singapore 159963",

      copyright:
        "© 2026 SP-JT-GABY Group. All rights reserved. SP-JT-GABY Group is an authorised representative of AIA Singapore Private Limited (Reg. No. 201106386R). This is not the official website of AIA Singapore Private Limited. Nothing on this website constitutes an offer or solicitation to sell insurance products. All AIA trademarks and logos remain the property of AIA and may not be used without prior written permission.",

      website: "Website by",
    },

    zh: {
      journey: "携手同行",
      desc: "为新加坡个人和企业提供金融咨询服务",

      contact: "联系我们",
      quick: "快速链接",
      services: "服务",

      about: "关于我们",
      meet: "团队成员",
      stay: "活动",
      careers: "招聘",
      contactus: "联系我们",

      privacy: "隐私政策",
      terms: "条款和条件",

      hours: "周一至周五：9:00 – 18:00",

      address1: "亚历山大路371号 #05-11",
      address2: "新加坡 159963",

      copyright:
        "© 2026 SP-JT-GABY Group 版权所有。SP-JT-GABY Group 是 AIA Singapore Private Limited（注册号：201106386R）的授权代表。本网站并非 AIA Singapore 官方网站。本网站内容不构成任何保险产品的要约或招揽。所有 AIA 商标及标识均归 AIA 所有，未经书面许可不得使用。",

      website: "网站制作",
    },

  };


  useEffect(() => {
    getAllServices()
      .then((res) => {
        if (res.data.success) {
          setServices(res.data.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);



  return (
    <footer className="bg-[#143c4c] text-white">

      <div className="max-w-[1200px] mx-auto px-6 py-12">

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">


          {/* ABOUT */}
          <div>

            <Link to="/">
              <img
                src="/assets/images/JT Group Logo Design.png"
                className="w-20 mb-3"
              />
            </Link>

            <div className="w-[150px] h-[2px] bg-white"></div>

            <h3 className="text-white text-lg font-medium mt-3 mb-4">
              {text[lang].journey}
            </h3>

            <p className="text-gray-300 text-sm leading-relaxed">
              {text[lang].desc}
            </p>


            <div className="text-left space-y-4 mt-6">

              <div className="flex items-center gap-4">

                <a className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-md">
                  <FaLinkedinIn size={16} />
                </a>

                <a className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-md">
                  <FaWhatsapp size={16} />
                </a>

                <a className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-md">
                  <FaInstagram size={16} />
                </a>

              </div>

            </div>

          </div>



          {/* CONTACT */}
          <div>

            <h3 className="text-lg font-semibold mb-6 text-[#c69c6d]">
              {text[lang].contact}
            </h3>

            <div className="space-y-4 text-sm text-gray-300">

              <div className="flex gap-3 items-start">
                <MapPin size={18} className="text-[#c69c6d]" />
                <div>
                  <p>{text[lang].address1}</p>
                  <p>{text[lang].address2}</p>
                </div>
              </div>

              <div className="flex gap-3">
                <Phone size={18} className="text-[#c69c6d]" />
                <p>+65 6123 4567</p>
              </div>

              <div className="flex gap-3">
                <Mail size={18} className="text-[#c69c6d]" />
                <p>info@jtgroup.com.sg</p>
              </div>

              <div className="flex gap-3">
                <Clock size={18} className="text-[#c69c6d]" />
                <p>{text[lang].hours}</p>
              </div>

            </div>

          </div>



          {/* QUICK LINKS */}
          <div>

            <h3 className="text-lg font-semibold mb-6 text-[#c69c6d]">
              {text[lang].quick}
            </h3>

            <ul className="space-y-3 text-sm text-gray-300">

              <li><Link to="/about">{text[lang].about}</Link></li>
              <li><Link to="/services">{text[lang].services}</Link></li>
              <li><Link to="/team">{text[lang].meet}</Link></li>
              <li><Link to="/events">{text[lang].stay}</Link></li>
              <li><Link to="/career">{text[lang].careers}</Link></li>
              <li><Link to="/contact">{text[lang].contactus}</Link></li>

            </ul>

          </div>



          {/* SERVICES */}
          <div>

            <h3 className="text-lg font-semibold mb-6 text-[#c69c6d]">
              {text[lang].services}
            </h3>

            <ul className="space-y-3 text-sm text-gray-300">

              {services.map((service) => (
                <li key={service._id}>
                  <Link to={`/services/${service._id}`}>
                    {service.title?.[langKey]}
                  </Link>
                </li>
              ))}

            </ul>

          </div>

        </div>



        {/* BOTTOM */}
        <div className="border-t border-white/40 mt-10 pt-6 flex flex-col md:flex-row items-center gap-4 text-xs text-gray-400">

          <p className="w-full md:w-[80%] text-center md:text-left text-[10px]">

            {text[lang].copyright}

            <span className="ml-1">

              {text[lang].website}{" "}

              <a
                href="https://anaxistech.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c69c6d] hover:underline"
              >
                AnaxisTech
              </a>

            </span>

          </p>

          <div className="w-full md:w-[20%] flex justify-center md:justify-end gap-6">

            <Link to="/privacy">
              {text[lang].privacy}
            </Link>

            <Link to="/termsconditions">
              {text[lang].terms}
            </Link>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;